import React, { RefObject } from 'react';
import { TimeRangeParam } from '../../types/DateRangeParam';
import { byName } from '../../utils/formParamsUtils';
import { BasicRange } from './BasicRange';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

type TimeRange = {
  timeRangeParam: TimeRangeParam<'timerange'>;
  labelStartTime: string;
  labelEndTime: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
};

export function TimeRange({ labelStartTime, labelEndTime, timeRangeParam, onBlur }: TimeRange) {
  const { t } = useSonTranslation('FormDateRange');

  return (
    <BasicRange
      start={timeRangeParam.params.find(byName('startTime'))}
      end={timeRangeParam.params.find(byName('endTime'))}
      labelStart={labelStartTime}
      labelEnd={labelEndTime}
      onBlur={onBlur}
      dateRangeTypeDependentValidation={(
        startRef: RefObject<HTMLInputElement | null>,
        endRef: RefObject<HTMLInputElement | null>
      ) => {
        if (startRef.current?.value === endRef.current?.value) {
          endRef.current?.setCustomValidity(t('endDateCanNotBeEqualStartDate'));
        }
      }}
    />
  );
}
